<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> Svn相关
                </el-breadcrumb-item>
                <el-breadcrumb-item>编辑人员信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <el-page-header @back="goBack" :content="'ID:' + form.id + ' 人员信息'" style="margin-bottom: 30px;"></el-page-header>
            <el-divider></el-divider>

            <div class="form-box">
                <el-form ref="form" :model="form" :rules="editRole" label-width="85px">
                    <el-form-item label="登录名" prop="username">
                        <el-input 
                            v-model="form.username"
                            disabled 
                            style="width: 80%;" 
                            class="edit-username">
                        </el-input>
                        <el-button @click.stop="showPasswdChange()" type="text" style="float: right">更改密码</el-button>
                    </el-form-item>
                    <el-form-item label="全名" prop="realUserName">
                        <el-input v-model="form.realUserName"></el-input>
                    </el-form-item>

                    <el-form-item label="密码" prop="passwd" v-show="showPasswd">
                        <el-input v-model="form.passwd" type="password" show-password></el-input>
                    </el-form-item>
                    <div style="margin-left: 85px" class="el-upload__tip" v-show="showPasswd">* 密码必须包含 1个数字,1个大写字母,1个小写字母</div>
                    <div style="margin-left: 85px; color: red;" class="el-upload__tip" v-show="showPasswdMsg">* 密码不能有顺序 {{passwdMsg}}</div>
                    <div style="margin-left: 85px; color: red;" class="el-upload__tip" v-show="showPasswdMsg2">* {{passwdMsg2}}</div>

                    <el-form-item label="确认密码" prop="passwordConfirm" v-show="showPasswd" style="margin-top: 20px">
                        <el-input v-model="form.passwordConfirm" type="password"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="电邮" prop="email" style="margin-top: 20px">
                        <el-input v-model="form.email"></el-input>
                    </el-form-item>
                    <div style="margin-left: 85px; color: red;" class="el-upload__tip" v-show="showEmailMsg">* 电邮地址 {{emailMsg}} 格式不对</div>
                    
                    <el-form-item label="描述" prop="description" style="margin-top: 20px">
                        <el-input v-model="form.description" :disabled="!showAuthorities"></el-input>
                    </el-form-item>

                    <el-form-item label="授予的角色" v-show="showAuthorities">
                        <el-checkbox-group v-model="form.authorities">
                            <el-checkbox v-for="item in init_authorities" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                        <span style="font-size: 9px; margin-left: 25px; color: #e6a23c">访问规则需要同时拥有 “版本库管理员” 和 “用户账户管理员” 才能进行访问</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { getPersonnelInfo, updatePersonnelInfo } from '../../api/svnAPI.js'
export default {
    name: 'svnEdit',
    data() {
        const checkPassword = (rule, value, callback) => {
            if (!value) {
                callback()
            } else if (value !== this.form.passwd) {
                callback(new Error("两次输入的密码不一致"))
            }
            callback()
        }

        const checkEmail = (rule, value, cb) => {
            const regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.]){1,2}[A-Za-z\d]{2,5}$/g
            if (regEmail.test(value)) {
                return cb()
            }
            cb(new Error('请输入正确的电邮地址'))
        }
        return {
            //SVN 服务地址
            serviceUrl: localStorage.getItem(localStorage.getItem('ms_username') + 'ServiceUrl'),

            showPasswd: false,  //修改密码框 展示

            form: {
                id: '',
                username: '',
                realUserName: '',
                passwd: '',
                passwordConfirm: '',
                email: '',
                description: '',
                authorities: '',  //默认选中

                passwd_change_active: '',

                urlStr: ''
            },
            //个人修改信息 就隐藏角色栏
            showAuthorities: true,  

            editRole: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur'}],
                realUserName: [{ required: true, message: '请输入全名', trigger: 'blur'}],
                passwd: [
                    { min: 8, message: '长度为不能小于8位', trigger: 'blur' },
                ],
                passwordConfirm: [
                    { validator: checkPassword }
                ],

                email: [
                    { required: true, message: '请输入电邮', trigger: 'blur'},
                    { validator: checkEmail}
                ],
            },

            init_authorities: [
                {
                    name: 'ROLE_ADMIN - 超级/根管理员（全部权限）',
                    id: 1
                },
                {
                    name: 'ROLE_ADMIN_HOOKS - Repository Hook Scripts Administrator',
                    id: 5
                },
                {
                    name: 'ROLE_ADMIN_REPO - 版本库管理员',
                    id: 4
                },
                {
                    name: 'ROLE_ADMIN_SYSTEM - 系统／服务器管理员',
                    id: 3
                },
                {
                    name: 'ROLE_ADMIN_USERS - 用户帐户管理员',
                    id: 6
                },
                {
                    name: 'ROLE_USER - 访问控制台所需基本用户权利',
                    id: 2
                }
            ],

            //passwd 非法序列提示
            showPasswdMsg: false,
            passwdMsg: '',
            //passwd 不满足要求
            showPasswdMsg2: false,
            passwdMsg2: '',
            //email  邮箱格式不对
            showEmailMsg: false,
            emailMsg: '',

            //身份令牌
            sessId: localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')
        };
    },
    created() {
        //刷新界面数据
        this.form.id = localStorage.getItem('svnEditId')
        this.initData()
    },
    mouanted() {
        //更新 SVN服务地址
        this.serviceUrl = localStorage.getItem(localStorage.getItem('ms_username') + 'ServiceUrl')
        this.sessId = localStorage.getItem(localStorage.getItem('ms_username') + 'sessId')
    },
    activated() {
        //刷新界面数据
        this.form.id = localStorage.getItem('svnEditId')
        this.initData()
    },
    methods: {
        //初始化页面
        initData() {
            this.showAuthorities = true  
            let params = {'id': this.form.id, 'url': this.serviceUrl, 'sessId': this.sessId}
            getPersonnelInfo(params).then(res => {
                if (res.data.code == 200) {
                    
                    this.form = res.data.data
                    this.form.id = localStorage.getItem("svnEditId")

                } else if (res.data.code == 777) {
                    this.$message.warning(res.data.message)
                    this.loginDialogVisible = true
                } else if (res.data.code == 721)  {
                    this.$message.warning('你没有执行此任务的授权')
                    this.$router.push('/svnManage')
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },

        //更改密码展示
        showPasswdChange() {
            this.showPasswd = !this.showPasswd
            
            //如果更改密码框关闭
            if (this.showPasswd == false) {
                this.form.passwd = undefined
                this.form.passwordConfirm = undefined

                this.showPasswdMsg = false
                this.showPasswdMsg2 = false
            }
        },

        //提交修改
        onSubmit() {
            //错误信息 隐藏
            this.showPasswdMsg = false
            this.showPasswdMsg2 = false
            this.showEmailMsg = false

            this.$refs.form.validate(valid => {
                if (valid) {
                    //判断是否修改密码
                    let flag = false
                    if(this.form.passwd !== undefined && this.form.passwd !== '') {
                        if(this.form.passwd == this.form.passwordConfirm) flag = true
                    }
                    
                    let params = {
                        id: this.form.id,
                        username: this.form.username,
                        realUserName: this.form.realUserName,
                        passwd: this.form.passwd,
                        passwordConfirm: this.form.passwordConfirm,
                        email: this.form.email,
                        description: this.form.description,
                        authorities: this.form.authorities,

                        //是否要密码
                        passwd_change_active: flag,

                        url: this.serviceUrl,
                        sessId: this.sessId
                    }
                    updatePersonnelInfo(params).then(res =>{
                        if (res.data.code == 200) {
                            this.$message.success('修改成功')

                            this.$router.go(-1)
                        } else if (res.data.code == 716) {     //参数信息错误
                            //密码非法序列 展示
                            if (res.data.data.passwdMsg !== undefined) {
                                this.passwdMsg = '密码不能有顺序'
                                this.showPasswdMsg = true
                            }
                            //密码不满足要求
                            if (res.data.data.passwdMsg2 !== undefined) {
                                this.passwdMsg2 = res.data.data.passwdMsg2
                                this.showPasswdMsg2 = true
                            }
                            //邮箱格式不对
                            if (res.data.data.emailMsg !== undefined) {
                                this.emailMsg = res.data.data.emailMsg
                                this.showEmailMsg = true
                            }
                            
                            //位置参数错误
                            if (res.data.data.errorMsg !== undefined) {
                                this.$message.error(res.data.data.errorMsg)
                            }

                        }else if (res.data.code == 777){     //登录身份过期
                            this.$message.warning(res.data.message)
                            this.loginDialogVisible = true

                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }
            })
        },

        //页头 - 返回
        goBack() {
            this.$router.go(-1)
        }
    }
};
</script>
<style scoped lang="scss">
::v-deep.edit-username > .el-input__inner{
    border: 0;
    background: #fff;
}
</style>